import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageItemProps } from "apis/page";
import { PaginationProps } from "utils/types/API";

export interface PageState {
    loading: boolean;
    list: {
        data: PageItemProps[];
        options: PageItemProps[];
        pagination?: PaginationProps;
        publishPages: PageItemProps[];
    };
    item: {
        data?: PageItemProps;
    };
}

const initialState: PageState = {
    loading: false,
    list: {
        data: [],
        options: [],
        publishPages: []
    },
    item: {
    }
};

interface IndexProps {
    data: PageItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: PageItemProps;
}
export const pageSlice = createSlice({
    name: "page",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        publishPages: (state, action: PayloadAction<IndexProps>) => {
            state.list.publishPages = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, publishPages, find, create, update } = pageSlice.actions;
export default pageSlice.reducer;
